module.exports = __webpack_public_path__ + "static/media/facebook-footer.4b8f0651.webp";